export default __webpack_public_path__ + "static/media/instagram.01b6282d.JPG";